import { PATRON_STATUS } from "components/Dashboard/consts"
import { formatNumberWithCommas, formatNumberWithCommasAndDecimal } from "components/helpers"

export const SUPPORT_COLUMN_WIDTH = {
    id: {
        width: '80px',
        isMobile: false
    },
    recepient: {
        width: '80px',
        isMobile: false
    },
    deposit: {
        width: '80px',
        isMobile: true
    },
    interest: {
        width: '60px',
        isMobile: false
    },
    claimed: {
        width: '100px',
        isMobile: false
    },
    available_w: {
        width: '100px',
        isMobile: false
    },
    status: {
        width: '100px',
        isMobile: true
    },
    action: {
        width: '140px',
        isMobile: false
    },
    mobile: {
        width: '50px',
        isMobile: true
    }
};


export const SUPPORT_HEADERS = [
    {
        id: 'id',
        name: 'Number',
        cell: SUPPORT_COLUMN_WIDTH.id
    },
    {
        id: 'recepient',
        name: 'Recepient',
        cell: SUPPORT_COLUMN_WIDTH.recepient
    },
    {
        id: 'deposit',
        name: 'Deposit',
        cell: SUPPORT_COLUMN_WIDTH.deposit
    },
    {
        id: 'interest',
        name: 'Interest',
        cell: SUPPORT_COLUMN_WIDTH.interest
    },
    {
        id: 'claimed',
        name: 'Claimed',
        cell: SUPPORT_COLUMN_WIDTH.claimed
    },
    {
        id: 'available_w',
        name: 'Available for withdrawal',
        cell: SUPPORT_COLUMN_WIDTH.available_w
    },
    {
        id: 'status',
        name: 'Status',
        cell: SUPPORT_COLUMN_WIDTH.status
    },
    {
        id: 'action',
        name: '',
        cell: SUPPORT_COLUMN_WIDTH.action
    },
    {
        id: 'mobile',
        name: 'Detailed',
        cell: SUPPORT_COLUMN_WIDTH.mobile,
    },
]

export const SUPPORT_ANALYTICS = [
    {
        id: '32433244',
        name: 'Total value',
        number: formatNumberWithCommas('', 8500),
        description: 'Total value deposited',
        helpText: 'help text about Total value deposited',

    },
    {
        id: '324344343424',
        name: 'Total interest',
        number: formatNumberWithCommasAndDecimal(9670),
        description: 'Total interest generated',
        helpText: 'help text about Total interest generated'
    },
    {
        id: '324434535324',
        name: 'Total beneficiaries',
        number: '3',
        description: 'Total number of beneficiaries',
        helpText: 'help text about Total number of beneficiaries',
        isCurrency: false,
    }
]

export const SUPPORT_MOCK_DATA = {
    headers: SUPPORT_HEADERS,
    columnWidth: SUPPORT_COLUMN_WIDTH,
    patrons: [
        {
            id: '7358539',
            recepient: 'Aleksandr F',
            deposit: formatNumberWithCommas('USDC', 1500),
            interest: '2%',
            claimed: formatNumberWithCommasAndDecimal(1100, '$'),
            available_w: formatNumberWithCommasAndDecimal(1400, '$'),
            status: PATRON_STATUS.FAILED,
            action: 'true',
            mobile: 'true'
        },
        {
            id: '7578539',
            recepient: 'Aleksandr F',
            deposit: formatNumberWithCommas('USDC', 1500),
            interest: '2%',
            claimed: formatNumberWithCommasAndDecimal(1100, '$'),
            available_w: formatNumberWithCommasAndDecimal(1400, '$'),
            status: PATRON_STATUS.IN_PROGRESS,
            action: 'true',
            mobile: 'true'
        },
        {
            id: '758539',
            recepient: 'Aleksandr F',
            deposit: formatNumberWithCommas('USDC', 1500),
            interest: '2%',
            claimed: formatNumberWithCommasAndDecimal(1100, '$'),
            available_w: formatNumberWithCommasAndDecimal(1400, '$'),
            status: PATRON_STATUS.WITHDREW,
            action: 'true',
            mobile: 'true'
        },
        {
            id: '758549',
            recepient: 'Ivanov F',
            deposit: formatNumberWithCommas('USDC', 1300),
            interest: '3%',
            claimed: formatNumberWithCommasAndDecimal(1500, '$'),
            available_w: formatNumberWithCommasAndDecimal(1300, '$'),
            status: PATRON_STATUS.CLAIMED,
            action: 'true',
            mobile: 'true'
        },
        {
            id: '758399',
            recepient: 'Olegov D',
            deposit: formatNumberWithCommas('USDC', 500),
            interest: '4%',
            claimed: formatNumberWithCommasAndDecimal(2500, '$'),
            available_w: formatNumberWithCommasAndDecimal(1200, '$'),
            status: PATRON_STATUS.UNCLAIMED,
            action: 'true',
            mobile: 'true'
        },
    ]
}